export default __webpack_public_path__ + "static/media/sid.de5b80ba.png";